module.exports = __webpack_public_path__ + "img/ajinesh.8438b54f.png";